export const PanelBottom = () => (
  <footer className="container text-center ">
    <div className="mg-b-2 col-sm-auto"></div>
    <small>
      &copy; 2019-{new Date().getFullYear()} ИГ & СД ЖК Город. All Rights
      Reserved.
    </small>
  </footer>
);
